import { LanesScorecardDTO } from '../dtos/lanes-scorecard-DTO';
import { LanesScorecardTable } from '../views/lanes-scorecard-table';
import { IS_NOT_NULL_OR_UNDEFINED } from '../../utils/commonUtils/validation-utils';
import { CAMEL_CASE } from '../../utils/stringUtils/index';

export const LANES_SCORECARDS_TABLE = (
	lanesList: Array<LanesScorecardDTO> = []
): Array<LanesScorecardTable> => {
	let results: Array<LanesScorecardTable> = [];
	try {
		if (lanesList.length > 0) {
			lanesList.map((lane) => {
				let row = {} as LanesScorecardTable;
				row.origin = `${CAMEL_CASE(lane.originCity)}, ${lane.originState.toUpperCase()}`;
				row.destination = `${CAMEL_CASE(
					lane.destinationCity
				)}, ${lane.destinationState.toUpperCase()}`;
				row.laneId = lane.laneId;
				row.loadsCount = lane.loadsCount;
				row.carriersCount = lane.carriersCount;

				row.totalBuy = IS_NOT_NULL_OR_UNDEFINED(lane.allInCost) ? lane.allInCost / 100 : null;
				row.forecastBuy = IS_NOT_NULL_OR_UNDEFINED(lane.predictedPrice)
					? lane.predictedPrice / 100
					: null;
				row.expectedMargin = IS_NOT_NULL_OR_UNDEFINED(lane.expectedMargin)
					? lane.expectedMargin / 100
					: null;
				row.actualMargin = IS_NOT_NULL_OR_UNDEFINED(lane.actualMargin)
					? lane.actualMargin / 100
					: null;
				row.revenue = IS_NOT_NULL_OR_UNDEFINED(lane.priceToShipper)
					? lane.priceToShipper / 100
					: null;

				results.push(row);
			});
		}
	} catch (error) {
		console.log('LANES_SCORECARDS_TABLE error: ', error);
	}

	return results;
};
